<rt-dialog-body variant="white">
  <div class="icon-container">
    <div class="icon-inner">
      <rt-icon name="close" size="large-x" colorToken="colorIconOncriticalDefault" />
    </div>
  </div>
  <div class="text-container">
    <rt-heading variant="heading" class="heading">
      {{ 'tlc.positions.skills_ideate_flow.result.failed.heading' | translate }}
    </rt-heading>
    <span class="description">{{
      'tlc.positions.skills_ideate_flow.result.failed.description' | translate
    }}</span>
  </div>
  <div class="buttons-container">
    <rt-button variant="tertiary" (click)="goBack()">
      <rt-icon name="arrow-back" />
      <span>{{ 'tlc.positions.skills_ideate_flow.result.failed.go_back' | translate }}</span>
    </rt-button>
    <rt-button variant="tertiary" (click)="close()">
      <rt-icon name="close" />
      <span>{{ 'tlc.positions.skills_ideate_flow.result.failed.close' | translate }}</span>
    </rt-button>
  </div>
</rt-dialog-body>
